import { render, staticRenderFns } from "./BaseDistributionBarChart.vue?vue&type=template&id=1403cf90"
import script from "./BaseDistributionBarChart.vue?vue&type=script&lang=js"
export * from "./BaseDistributionBarChart.vue?vue&type=script&lang=js"
import style0 from "./BaseDistributionBarChart.vue?vue&type=style&index=0&id=1403cf90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports